import { cEl } from '../../../../../util';
import users from '../../../../../assets/images/users.svg';
import tool from '../../../../../assets/images/tool.svg';
import user from '../../../../../assets/images/user.svg';

function SelectionCriteriaSlide() {
    const selectionCriteriaSlide = cEl('article');
    selectionCriteriaSlide.classList.add('carousel-slide', 'selection-criteria-slide');
    selectionCriteriaSlide.innerHTML = `
    <h2>성공적으로 활용하기 위한 시나리오 선택 기준</h2>
    <div class="slide-item-list">
        <div class="slide-item">
            <div class="img-container">
                <img src="${users}" alt="users" />    
            </div>
            <div>
                <div class="sub-topic">협조적인 부서</div>
                같은 로봇도 누가 쓰느냐에 따라 활용도가 달라집니다.<br>
                로봇 사용에 적극적인 부서를 우선 선정하고, <span class="text-highlight">사용자 간의 협력과 조율</span>이 중요합니다.        
            </div>
        </div>
        <div class="slide-item">
            <div class="img-container">
                <img src="${tool}" alt="tool" />
            </div>
            <div>
                <div class="sub-topic">에러에 유연한 업무</div>
                초기 도입 시 다양한 에러가 발생할 수 있습니다.<br>
                에러 발생 시 <span class="text-highlight">기존 방식으로 대응할 수 있는 업무</span>를 선택하세요.        
            </div>
        </div>
        <div class="slide-item">
            <div class="img-container">
                <img src="${user}" alt="user" />
            </div>
            <div>
                <div class="sub-topic">인력이 부족한 부서 우선 선정</div>
                인력이 부족한 부서에 로봇을 투입해 <span class="text-highlight">단순 업무를 줄여서 중요한 업무에 집중</span>할 수 있도록 하면 로봇<br>사용의 정착율이 높아집니다.        
            </div>
        </div>
    </div>
    `;
    return selectionCriteriaSlide;
}

export default SelectionCriteriaSlide;
